import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../Config";
import { IoCopySharp } from "react-icons/io5";
import moment from "moment";
import { capitalizeFirstLetter, handleCopy } from "../../helpers";
import { FiChevronRight, FiDownload, FiShare2 } from "react-icons/fi";
import Tooltip from "../Tooltip";
import { FaSpinner } from "react-icons/fa";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import { toast } from "react-toastify";

const Table = ({
  apiData,
  setSelectedData,
  getInventoryListMutate,
  downloadReceiptMutate,
  downloadLoading,
  setIsDeleteReceipt,
}) => {
  const storageKey = `landlord_list_page`;
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const [selectedRow, setSelectedRow] = useState(null);
   const [sharingId, setSharingId] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [openActionMenu, setOpenActionMenu] = useState(null);

  // Load saved page index
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const handleDownloadReceipt = (item) => {
  if (!item?.id) return;

  setSelectedData(item);
  setSharingId(item.id);

  downloadReceiptMutate(item.id, {
    onSettled: () => setSharingId(null),
  });
};

const deleteReceipt = (item) => {
  setSelectedData(item);
  setIsDeleteReceipt(true);
};
  const ActionBtns = (item) => (
  <div className="flex items-center gap-3">
    <Tooltip label="Download Invoice">
      <button
        onClick={() => handleDownloadReceipt(item)}
        disabled={sharingId === item.id}
        className="text-gray-400 hover:text-primary-color transition bg-gray-50 hover:bg-primary-color/10 rounded-full p-1.5"
      >
        {sharingId === item.id ? (
          <FaSpinner className="animate-spin" size={14} />
        ) : (
          <FiDownload size={16} />
        )}
      </button>
    </Tooltip>

    <Tooltip label="Delete Invoice">
      <button
        onClick={() => deleteReceipt(item)}
        className="text-gray-400 hover:text-rose-600 transition bg-gray-50 rounded-full p-1.5"
      >
        <MdDelete size={16} />
      </button>
    </Tooltip>
  </div>
);

  useEffect(() => {
    if (Array.isArray(apiData)) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        // subtotal:getRate(item),
        grandTotal: getGrandTotal(item),
        receiptDate: moment(item?.receiptDate).format("DD MMM YYYY"),
        createdAt: moment(item?.createdAt).format("DD MMM YYYY"),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  // const getOwnerTooltip = (item) => {
  //   return (
  //     <div className="min-w-[220px] text-xs">
  //       {item?.gstin?.trim() && (
  //         <div className="flex justify-between py-1 gap-4">
  //           <span className="text-gray-400">GST No.</span>
  //           <span className="font-medium text-right break-all">
  //             {item.gstin}
  //           </span>
  //         </div>
  //       )}

  //       {item?.receiptDate && (
  //         <div className="flex justify-between py-1 gap-4">
  //           <span className="text-gray-400">Receipt Date</span>
  //           <span className="font-medium">
  //             {moment(item.receiptDate).format("DD MMM YYYY")}
  //           </span>
  //         </div>
  //       )}

  //       {item?.address?.trim() && (
  //         <div className="border-t mt-2 pt-2">
  //           <div className="text-gray-400 mb-1">Address</div>
  //           <div className="font-medium break-words">
  //             {item.address}
  //           </div>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };
// const getOwnerTooltip = (item) => {
//   const fields = [
//     item?.gstin?.trim() && (
//       <span>
//         <strong>GST No:</strong> {item.gstin}
//       </span>
//     ),
//     item?.receiptDate && (
//       <span>
//         <strong>Receipt Date:</strong>{" "}
//         {moment(item.receiptDate).format("DD MMM YYYY")}
//       </span>
//     ),
//     item?.address?.trim() && (
//       <span>
//         <strong>Address:</strong> {item.address}
//       </span>
//     ),
//   ].filter(Boolean);

//   if (fields.length === 0) {
//     return null;
//   }

//   return (
//     <div className="flex flex-col text-xs text-left gap-0.5">
//       {fields}
//     </div>
//   );
// };
const getOwnerTooltip = (item) => {
  return (
    <div className="flex flex-col text-xs text-left gap-1 min-w-[170px] max-w-[190px]">
      {item?.gstin?.trim() && (
        <div className="flex justify-between">
          <strong className="text-gray-500 font-medium">GST No:</strong>
          <span>{item.gstin}</span>
        </div>
      )}

      {item?.receiptDate && (
        <div className="flex justify-between">
          <strong className="text-gray-500 font-medium">
            Invoice Date:
          </strong>
          <span>{moment(item.receiptDate).format("DD MMM YYYY")}</span>
        </div>
      )}

      {item?.address?.trim() && (
        <div className="border-t mt-1 pt-1">
          <strong className="text-gray-500 font-medium block mb-0.5">
            Address:
          </strong>
          <span className="break-words">{item.address}</span>
        </div>
      )}
    </div>
  );
};
  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.ownerName || "N/A");

    return (
      <Tooltip label={getOwnerTooltip(item)}>
        <UserImageWrapper
        >
          {/* <UserImage src={Images.Avatar} alt={name} /> */}

          <div className="flex flex-col min-w-0">
            <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">
              {name}
            </span>

            <div className="flex items-center gap-1 text-xs text-gray-400">
              <span>#{item.receiptNo}</span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(item.receiptNo);
                }}
                className="hover:text-gray-600 transition"
                title="Copy receipt no"
              >
                <IoCopySharp size={12} />
              </button>
            </div>
          </div>
        </UserImageWrapper>
      </Tooltip>
    );
  };




//   const getGrandTotal = (item) => {
//   const hasCGST = Number(item?.cgstAmount || 0) > 0;
//   const hasSGST = Number(item?.sgstAmount || 0) > 0;
//   const hasIGST = Number(item?.igstAmount || 0) > 0;

//   const hasTax = hasCGST || hasSGST || hasIGST;

//     const content = (
//       <div className="flex flex-col cursor-help">
//         <span className="font-medium cursor-pointer">
//           ₹ {Number(item?.grandTotal || 0).toLocaleString("en-IN")}
//         </span>
//       </div>
//     );

//     return (
//       <Tooltip
//         label={
//           <div className="min-w-[150px] text-xs">
//             <div className="flex justify-between py-1">
//               <span>Amount</span>
//               <span>
//                 ₹ {Number(item?.subtotal || 0).toLocaleString("en-IN")}
//               </span>
//             </div>

//             {hasCGST && (
//               <div className="flex justify-between py-1">
//                 <span>CGST</span>
//                 <span>₹ {Number(item.cgstAmount).toLocaleString("en-IN")}</span>
//               </div>
//             )}

//             {hasSGST && (
//               <div className="flex justify-between py-1">
//                 <span>SGST</span>
//                 <span>₹ {Number(item.sgstAmount).toLocaleString("en-IN")}</span>
//               </div>
//             )}

//             {hasIGST && (
//               <div className="flex justify-between py-1">
//                 <span>IGST</span>
//                 <span>₹ {Number(item.igstAmount).toLocaleString("en-IN")}</span>
//               </div>
//             )}

//             {hasTax && (
//               <div className="border-t mt-2 pt-2 flex justify-between font-semibold text-sm">
//                 <span>Total</span>
//                 <span>
//                   ₹ {Number(item.grandTotal).toLocaleString("en-IN")}
//                 </span>
//               </div>
//             )}
//           </div>
//         }
//       >
//       {content}
//     </Tooltip>
//   );
// };
// const getGrandTotal = (item) => {
//   const hasCGST = Number(item?.cgstAmount || 0) > 0;
//   const hasSGST = Number(item?.sgstAmount || 0) > 0;
//   const hasIGST = Number(item?.igstAmount || 0) > 0;

//   const hasTax = hasCGST || hasSGST || hasIGST;

//   const content = (
//     <div className="flex flex-col">
//       <span
//         className={`font-medium ${hasTax ? "cursor-help" : ""}`}
//       >
//         ₹ {Number(item?.grandTotal || 0).toLocaleString("en-IN")}
//       </span>
//     </div>
//   );

//   // No GST → don't show tooltip
//   if (!hasTax) {
//     return content;
//   }

//   return (
//     <Tooltip
//       label={
//         <div className="flex flex-col text-xs text-left gap-0.5 min-w-[170px]">
//           <div className="flex justify-between">
//             <strong className="text-gray-500 font-medium">Amount:</strong>
//             <span>₹ {Number(item?.subtotal || 0).toLocaleString("en-IN")}</span>
//           </div>

//           {hasCGST && (
//             <div className="flex justify-between">
//               <strong className="text-gray-500 font-medium">CGST:</strong>
//               <span>₹ {Number(item.cgstAmount).toLocaleString("en-IN")}</span>
//             </div>
//           )}

//           {hasSGST && (
//             <div className="flex justify-between">
//               <strong className="text-gray-500 font-medium">SGST:</strong>
//               <span>₹ {Number(item.sgstAmount).toLocaleString("en-IN")}</span>
//             </div>
//           )}

//           {hasIGST && (
//             <div className="flex justify-between">
//               <strong className="text-gray-500 font-medium">IGST:</strong>
//               <span>₹ {Number(item.igstAmount).toLocaleString("en-IN")}</span>
//             </div>
//           )}

//           <div className="flex justify-between border-t mt-1 pt-1">
//             <strong className="text-gray-700">Total:</strong>
//             <span className="font-semibold">
//               ₹ {Number(item.grandTotal).toLocaleString("en-IN")}
//             </span>
//           </div>
//         </div>
//       }
//     >
//       {content}
//     </Tooltip>
//   );
// };
const getGrandTotal = (item) => {
  const hasCGST = Number(item?.cgstAmount || 0) > 0;
  const hasSGST = Number(item?.sgstAmount || 0) > 0;
  const hasIGST = Number(item?.igstAmount || 0) > 0;

  const hasTax = hasCGST || hasSGST || hasIGST;

  const content = (
    <div className="flex flex-col">
      <span
        className={`font-medium ${hasTax ? "cursor-pointer" : ""}`}
      >
        ₹ {Number(item?.grandTotal || 0).toLocaleString("en-IN")}
      </span>
    </div>
  );

  // No GST → don't show tooltip
  if (!hasTax) {
    return content;
  }

  return (
    <Tooltip
      label={
        <div className="flex flex-col text-xs text-left gap-0.5 min-w-[170px]">
          <div className="flex justify-between">
            <strong className="text-gray-500 font-medium">Amount:</strong>
            <span>₹ {Number(item?.subtotal || 0).toLocaleString("en-IN")}</span>
          </div>

          {hasCGST && (
            <div className="flex justify-between">
              <strong className="text-gray-500 font-medium">CGST:</strong>
              <span>₹ {Number(item.cgstAmount).toLocaleString("en-IN")}</span>
            </div>
          )}

          {hasSGST && (
            <div className="flex justify-between">
              <strong className="text-gray-500 font-medium">SGST:</strong>
              <span>₹ {Number(item.sgstAmount).toLocaleString("en-IN")}</span>
            </div>
          )}

          {hasIGST && (
            <div className="flex justify-between">
              <strong className="text-gray-500 font-medium">IGST:</strong>
              <span>₹ {Number(item.igstAmount).toLocaleString("en-IN")}</span>
            </div>
          )}

          <div className="flex justify-between border-t mt-1 pt-1">
            <strong className="text-gray-700">Total:</strong>
            <span className="font-semibold">
              ₹ {Number(item.grandTotal).toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      }
    >
      {content}
    </Tooltip>
  );
};
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Company/Owner",
          accessor: "name",
        },
        {
          Header: "Total Amount",
          accessor: "grandTotal",
        },
      ];
    }
    return [
      {
        Header: "Company/Owner",
        accessor: "name",
      },
      {
        Header: "Total Amount",
        accessor: "grandTotal",
      },
      // {
      //   Header: "Generated On",
      //   accessor: "receiptDate"
      // },
      {
        Header: "Created At",
        accessor: "createdAt",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    //setCurrentPage(pageIndex);
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            const rowData = apiData[rowIndex];
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Rent</strong> {data[rowIndex].rent}
                        </li>
                        <li>
                          <strong>Rent Date</strong> {data[rowIndex].rentDate}
                        </li>
                        <li>
                          <strong>Agreement Duration</strong>{" "}
                          {data[rowIndex].agreementDuration}
                        </li>
                        <li>
                          <strong>Action</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer`;
const UserImage = tw.img`w-10 h-10 rounded-full `;

export default Table;
